import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as FilterGroup from '../filter-group'
import * as Constants from './constants'

export const fetchFilterGroups: IsActive.FilteredFetcher = IsActive.filteredFetchAction(
  Constants.FETCH_FILTER_GROUPS,
  Constants.SERVER_RESOURCE,
)

// Active/Inactive
export const updateStatus: IsActive.UpdateStatusAction = (community: string, stateChange: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.UPDATE_FILTER_GROUP_INLINE)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `${Constants.SERVER_RESOURCE}/${community}/${stateChange.id}`,
  })

export const createFilterGroup = FilterGroup.createFilterGroupAction(Constants.ADD_FILTER_GROUP)

export const toggleAddFilterGroupModal: Modal.Toggle = Modal.toggleModal(Constants.ADD_FILTER_GROUP)
export const updateAddFilterGroupModalField: Modal.Update = Modal.updateModal(Constants.ADD_FILTER_GROUP)



// WEBPACK FOOTER //
// ./src/pages/filter-groups/actions.ts